<template>
    <div>
        <payoffCounty v-if="areaType === 'COUNTY'"></payoffCounty>
        <payoffCity v-else></payoffCity>
    </div>
</template>
<script>
    import payoffCity from './payoffCity';
    import payoffCounty from './payoffCounty';
    export default {
        data(){
            return {
                areaType: localStorage.getItem('areaType'),
            };
        },
        components:{
            payoffCity,
            payoffCounty
        },
        computed:{
        },
        watch: {

        },
        created(){
        },
        mounted(){},
        methods: {
        }
    };
</script>
